import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconVerified = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconVerified",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m438-452-58-57q-11-11-27-11t-29 12q-11 11-11 28t11 28l86 86q12 12 28 12t28-12l170-170q12-12 12-28t-12-28-28-12-29 11zM326-90l-58-98-110-24q-15-3-24-15t-7-28l11-113-75-86q-10-11-10-26t10-26l75-86-11-113q-2-15 7-27t24-16l110-24 58-98q8-13 22-17t28 1l104 44 104-44q14-6 28-1t22 17l58 98 110 24q15 3 24 16t7 27l-11 113 75 86q10 11 10 26t-10 26l-75 86 11 113q2 15-7 28t-24 15l-110 24-58 98q-8 13-22 18t-28-2l-104-44-104 44q-14 6-28 2t-22-18"
  })
}));
IconVerified.displayName = 'IconVerified';